import { Dispatch, SetStateAction } from "react";
import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";

import CustomText from "../../general/CustomText/CustomText";
import CustomDropdown from "../../general/CustomDropDown/CustomDropdown";

interface FilterDropdownProps {
  filterValue: string;
  setFilterValue: Dispatch<SetStateAction<string>>;
  filterDropdownOpen: boolean;
  setFilterDropdownOpen: Dispatch<SetStateAction<boolean>>;
  filterItems: { label: string; value: string }[];
  label?: string;
  customStyle?: StyleProp<ViewStyle>;
  placeholder?: string;
  fullWidth?: boolean;
}

const FilterDropdown = ({
  filterValue,
  setFilterValue,
  filterDropdownOpen,
  setFilterDropdownOpen,
  filterItems,
  label,
  customStyle = {},
  placeholder,
  fullWidth = false,
}: FilterDropdownProps) => {
  return (
    <View style={styles.filterContainer} id={`${label || "filter"}-dropdown`}>
      {label && <CustomText size="s" style={[styles.filterLabel, customStyle]} text={label} />}
      <CustomDropdown
        options={filterItems}
        value={filterValue}
        onChange={(value) => {
          setFilterValue(value || "");
          setFilterDropdownOpen(false);
        }}
        open={filterDropdownOpen}
        onOpenChange={setFilterDropdownOpen}
        placeholder={placeholder}
        fullWidth={fullWidth}
        dropdownContainerStyle={[styles.dropdownContainer, fullWidth && styles.dropdownContainerFullWidth]}
        dropdownStyle={[styles.dropdownField, fullWidth && styles.dropdownFieldFullWidth]}
      />
    </View>
  );
};

export default FilterDropdown;

const styles = StyleSheet.create({
  filterContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 8,
    zIndex: 3000,
    elevation: 3000,
  },
  filterLabel: {
    color: "#667085",
    // minWidth: 50,
    marginRight: 8,
    display: "flex",
    flexWrap: "nowrap",
    flexShrink: 0,
  },
  dropdownContainer: {
    borderColor: "rgb(229, 231, 235)",
    backgroundColor: "white",
    zIndex: 3000,
    elevation: 3000,
  },
  dropdownField: {
    borderColor: "rgb(229, 231, 235)",
    zIndex: 3000,
    elevation: 3000,
    minHeight: 42.5,
    backgroundColor: "white",
    borderRadius: 6,
    borderWidth: 1,
  },
  dropdownContainerFullWidth: {
    width: "100%",
  },
  dropdownFieldFullWidth: {
    width: "100%",
  },
});
